import { Avatar, Box, Paper, Typography } from "@mui/material"
import { AvatarStyleTypeBuilder, UserPicture } from "../../UserPicture/UserPicture"
import React from "react";
import { useProfile } from "../../../context/ProfileProvider/useProfile";

interface IPaperLayer {
    open: boolean;
    handleClick: (e: React.MouseEvent<HTMLElement>) => void;
}

export const PaperLayer: React.FC<IPaperLayer> = ({
    open,
    handleClick
}) => {

    const profile = useProfile();

    return (
        <Paper
            elevation={open ? 6 : 0}
            sx={{
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                marginLeft: "15px"
            }}
        >
            <Box
                min-width="208px"
                height="46px"
                padding="5px 10px 5px 5px"
                borderRadius="4px"
                display="flex"
                alignItems="center"
                sx={{
                    border: "1px solid #00000000",
                    ':hover': {
                    border: "1px solid #0000001A"
                    }
                }}
                onClick={handleClick}
            >
                <Box>
                    <UserPicture 
                        style={AvatarStyleTypeBuilder.normal}
                        source={profile.userPicture == undefined || profile.userPicture == "" ? profile.picture : profile.userPicture}
                        username={profile?.username}
                    />
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                >
                    <Typography
                        textAlign="left"
                        fontWeight="600"
                        color="#2D2D2D"
                        fontSize="14px"
                        whiteSpace="nowrap"
                        width="150px"
                        textOverflow="ellipsis"
                        overflow="hidden"
                        component="span"
                    >
                        { profile?.username }
                    </Typography>
                    <Typography
                        textAlign="left"
                        color="#2D2D2D"
                        fontSize="12px"
                        sx={{ opacity: .5 }}
                    >
                    { profile?.login }
                    </Typography>
                </Box>
            </Box>
        </Paper>
    )
}